import { render, staticRenderFns } from "./BooleanEditor.vue?vue&type=template&id=f85a5e24&scoped=true&"
import script from "./BooleanEditor.vue?vue&type=script&lang=js&"
export * from "./BooleanEditor.vue?vue&type=script&lang=js&"
import style0 from "./BooleanEditor.vue?vue&type=style&index=0&id=f85a5e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85a5e24",
  null
  
)

export default component.exports